import { useState } from "react";
import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import { PlusIcon } from "@heroicons/react/24/outline";
import { TransferAgentForm } from "./TransferAgentForm";
import { message } from "antd";

function TransferAgentEdit(props) {
  const { agent, updateAgent, open, onClose, assistantType, availableSlotTags } = props;
  const [loading, setLoading] = useState(false);

  const defaultTransferAgent = {
    name: agent.name,
    phoneNumber: agent.phoneNumber,
    email: agent.email,
    trigger: agent.trigger,
    slotTag: agent?.slotTag,
  };

  const handleSubmit = (data) => {
    updateAgent(data)
      .then(() => {
        setLoading(false);
        onClose();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {open && (
        <Dialog
          open={open}
          onClose={onClose}
        >
          <DialogTitle>Edit Agent</DialogTitle>
          <DialogBody>
            <TransferAgentForm
              assistantType={assistantType}
              defaultTransferAgent={defaultTransferAgent}
              onSubmit={handleSubmit}
              onCancel={onClose}
              loading={loading}
              setLoading={setLoading}
              buttonInfo={{
                buttons: "2",
                primaryLabel: "Save",
                secondaryLabel: "Cancel",
              }}
              availableSlotTags={availableSlotTags}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}

export { TransferAgentEdit };
